export interface Testimonial {
  name: string;
  image?: string;
  citation: string;
  longDescription: string;
  logo?: string;
  role: string;
  datePublished: string;
  rating: number;
}

export const testimonialsData: Testimonial[] = [
  {
    name: "Unternehmer aus dem Mittelstand",
    image: undefined,
    citation: "Unein&shy;geschränkt empfehlens&shy;wert",
    longDescription:
      "Uns begleitet Solving Legal ganzheitlich bei gesellschaftsrechtlichen Fragestellungen und Beteiligungsszenarien. Eine Zusammenarbeit mit der Kanzlei kann ich uneingeschränkt empfehlen.",
    logo: undefined,
    role: "Geschäftsführer und Gesellschafter",
    datePublished: "2024-01-15",
    rating: 5,
  },
  {
    name: "Unternehmer",
    image: undefined,
    citation: "100 % verlässlich - gerade in den kritischen Phasen",
    longDescription:
      "Gerade in den kritischen Phasen der Auseinandersetzung konnte ich mich zu 100 % auf Solving Legal verlassen.",
    logo: undefined,
    role: "Mehrheitsgesellschafter",
    datePublished: "2024-02-20",
    rating: 5,
  },
  {
    name: "Paul Arnoldt",
    image: undefined,
    citation:
      "Wirtschaft&shy;lich, steuer&shy;lich und persön&shy;lich ein äußerst gutes Ergebnis",
    longDescription:
      "Hubertus von Solving Legal hat mich in einem eskalierten Gesellschafterstreit umfassend beraten und unterstützt. Sein besonderes Einfühlungsvermögen, kombiniert mit seinen herausragenden verhandlungsstrategischen Fähigkeiten, ermöglichte es mir, mit meinen Mitgesellschaftern eine außergerichtliche Lösung zu finden – eine Lösung, die für mich wirtschaftlich, steuerlich und persönlich ein äußerst gutes Ergebnis darstellt.",
    logo: undefined,
    role: "Gründer, Geschäftsführer",
    datePublished: "2024-03-10",
    rating: 5,
  },
];
